<template>
    <div>
        <form-contract-client-e-e :disabled="isDisabled"/>
        <form-client-delivery :disabled="isDisabled"/>
        <form-client-installation-risk :disabled="isDisabled"/>
        <form-client-emergency :disabled="isDisabled"/>
        <form-transfer-certificate :disabled="isDisabled"/>
    </div>
</template>

<script>
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'

import formContractClientEE
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formContractClientEE"
import formClientDelivery
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formClientDelivery"
import formTransferCertificate
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formTransferCertificate"
import formClientInstallationRisk
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formClientInstallationRisk"
import formClientEmergency
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formClientEmergency"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocuments/getField',
    mutationType: 'masterInstallationDocuments/updateField',
})

export default {
    name: "FormGeneralDataAndRisksView",
    components: {
        formContractClientEE,
        formClientDelivery,
        formTransferCertificate,
        formClientInstallationRisk,
        formClientEmergency

    },
    data() {
        return {
            SpanishLocale,
            edit: false,
            showLoading: false,
            isDisabled: false
        }
    },
    computed: {
        ...mapState('masterInstallationDocuments', []),
        ...mapFields({

        }),
    },
    created() {

    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>